import { COMPOSITE_ID_SEPARATOR } from './formatters.constant';

export const makeCompositeId = (parts: (string | number)[]) => parts.join(COMPOSITE_ID_SEPARATOR);

export const splitCompositeId = (value: string) => value?.split(COMPOSITE_ID_SEPARATOR);
